'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ConfirmButton = require('./components/ConfirmButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ConfirmButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/confirm-button/index.js
// module id = 1283
// module chunks = 0